import { useState } from "react";
import styles from "../mybooking.module.css";
import { Button, Menu, MenuItem } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { Eye, Mail, Printer, X } from "react-feather";

const ActionMenu = ({ item, setViewModalOpen, setViewId, setViewStr, setSendInvoiceModalOpen, setInvoiceMail, setInvoiceMailId, printBooking, setCancelModalOpen, setCancelId }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    return (<>
        <Button className={`${styles.ActionBU}`} disableElevation endIcon={<KeyboardArrowDownIcon />} onClick={(e) => { setAnchorEl(e.currentTarget); }}>Actions</Button>
        <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={(e) => setAnchorEl(null)}
            className={`${styles.ActionMenuSec}`}
        >
            <MenuItem onClick={(e) => { setAnchorEl(null); setViewModalOpen(true); setViewId(item?.id); setViewStr(item?.booking_id); }}><Eye /> View Booking</MenuItem>
            {parseInt(item?.status) > -1 && <MenuItem onClick={(e) => { setAnchorEl(null); setCancelModalOpen(true); setCancelId(item?.id); }}><X /> Cancel This Bookings</MenuItem>}
            <MenuItem onClick={(e) => { setAnchorEl(null); printBooking(item?.id); }}><Printer /> Print This Bookings</MenuItem>
            {parseInt(item?.status) >= 2 && <MenuItem onClick={(e) => { setAnchorEl(null); setSendInvoiceModalOpen(true); setInvoiceMailId(item?.id); setInvoiceMail(item?.customer_email); }}><Mail /> Send Invoice</MenuItem>}
        </Menu>
    </>);
}

export default ActionMenu;